<template>
  <div class="card" id="variant-id">
    <div class="card-body">
      <div class="divide-y">
        <label class="row">
          <span class="col-4">
            <span class="title">Вариант поста</span>
          </span>
          <span class="col-8">
            <select class="form-select" v-model="fields.variant_id" @change="onChange">
              <option :key="val.id" :value="val.id" v-for="val in getValues()">{{ val.name }}</option>
            </select>

            <div class="mb-3" v-if="v$.variant_id.$invalid && v$.variant_id.$dirty">
              <span :class="{'is-invalid': v$.variant_id.$invalid && v$.variant_id.$dirty}"></span>
              <div class="invalid-feedback" v-for="error of v$.variant_id.$silentErrors" :key="error.$uid">
                {{ error.$message }}
              </div>
            </div>
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, ref, watch, onMounted, reactive} from "vue"
import {between} from "@/plugins/vuelidator"
import {useVuelidate} from "@vuelidate/core/dist/index.esm"

export default defineComponent({
  name: "VariantId",
  props: {
    data: {
      type: [Object, null],
      default: null,
    },
  },
  setup(props, {emit}) {
    let values = ref([
      {
        "id": null,
        "name": "Не выбрано",
      },
      {
        "id": 1,
        "name": "БАДы",
      },
      {
        "id": 2,
        "name": "Лекарственные препараты",
      },
    ])

    let selectVal = ref(null)

    let $externalResults = reactive({})

    const fields = reactive({
      variant_id: selectVal.value,
    })

    const rules = {
      variant_id: {
        between: between(1, 2)
      },
    }

    const v$ = useVuelidate(rules, fields, {$externalResults})

    function validate(fn) {
      v$.value.$clearExternalResults()

      return v$.value.$validate().then(async () => {
        await fn()
      })
    }

    onMounted(() => {
      setCurrentValue(props.data["val"])
    })

    watch(() => props.data["val"], (val) => {
      setCurrentValue(val)
    })

    watch(() => props.data["validations"], (val) => {
      validate(() => {
        if (val?.variant_id !== undefined) {
          $externalResults.variant_id = val["variant_id"][0]
        }
      })
    })

    function setCurrentValue(val) {
      fields.variant_id = val;
    }

    function getValues() {
      return values.value;
    }

    function onChange() {
      validate(() => {})
      changeEmit(fields.variant_id)
    }

    function changeEmit(val) {
      emit("onChange", val)
    }

    return {
      onChange,
      getValues,
      v$,
      fields,
    }
  }
})
</script>

<style scoped>

</style>
